import React, { useState } from "react";
import { Info, ChevronDown, ChevronUp } from "lucide-react";

const TIPS = [
  { t: "Find a quiet spot", b: "A room with the window closed and the telly off. Kitchens, cars and cafés carry more noise than you'd think." },
  { t: "Hold your phone close", b: "About a hand's width from your mouth (roughly 20 cm). Closer than that muffles it; further, and background noise creeps in." },
  { t: "Take a breath, then begin", b: "A moment of silence at the start helps the transcription settle. Speak at your natural pace — pauses are fine." },
  { t: "One recording at a time", b: "Take as long as you need. If you start a new recording, it will replace the previous one — so listen back before recording again." },
  { t: "Regional accents are welcome", b: "Midlands, Yorkshire, Glasgow, Cardiff — the transcript adapts. You can also edit any word by hand afterwards." },
  { t: "Names help", b: "If you say a name or place that matters, you can type it in the box afterwards — the recording keeps the voice, the text keeps the spelling." },
];

/**
 * Reusable recording-tips card.
 * variant="panel" — always-open panel (Welcome page)
 * variant="toggle" — collapsible next to the mic (Day pages)
 */
export function RecordingTips({ variant = "toggle", className = "" }) {
  const [open, setOpen] = useState(variant === "panel");
  return (
    <div
      className={`hairline-cream bg-white ${className}`}
      style={{ borderRadius: 4 }}
      data-testid="recording-tips"
    >
      {variant === "toggle" ? (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="w-full flex items-center justify-between px-5 py-3 text-left"
          style={{ minHeight: 44 }}
          aria-expanded={open}
          aria-controls="recording-tips-body"
          data-testid="recording-tips-toggle"
        >
          <span className="flex items-center gap-2 label-ui text-[11px] text-[#B8973A] tracking-[0.25em]">
            <Info size={14} /> TIPS FOR RECORDING YOUR VOICE
          </span>
          {open ? <ChevronUp size={16} className="text-[#8C8278]" /> : <ChevronDown size={16} className="text-[#8C8278]" />}
        </button>
      ) : (
        <div className="px-6 py-5 border-b hairline-cream">
          <p className="flex items-center gap-2 label-ui text-[11px] text-[#B8973A] tracking-[0.25em]">
            <Info size={14} /> TIPS FOR RECORDING YOUR VOICE
          </p>
        </div>
      )}
      {open && (
        <ul
          id="recording-tips-body"
          className="px-6 py-4 space-y-3"
          style={{ fontFamily: "Georgia, serif", fontSize: "16px", lineHeight: 1.55 }}
        >
          {TIPS.map((tip, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="text-[#B8973A] mt-0.5 shrink-0" style={{ fontFamily: "Cormorant Garamond, serif" }}>✦</span>
              <span className="text-[#1B2A4A]">
                <strong className="text-[#111D33]">{tip.t}.</strong>{" "}
                <span className="text-[#3E4C66]">{tip.b}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default RecordingTips;
